import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class PaymentService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(error as T);
    };
  }

  public requestPayfastPayment(paymentDetails: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'payment/request', paymentDetails,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );
  }

  public requestPeachPayment(paymentDetails: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'peach/request', paymentDetails,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );
  }
}
